// extracted by mini-css-extract-plugin
export var button = "_mp-2";
export var card = "_mp-0";
export var closeButtonContainer = "_mp-3";
export var iconContainer = "_mp-1";